function Boxing({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 40C14 41.1 14.9 42 16 42H32C33.1 42 34 41.1 34 40V34H14V40Z" fill=${`"${col}"`}/>
      <path d="M36 14C34.9 14 34 14.9 34 16V10C34 7.8 32.2 6 30 6H14C11.8 6 10 7.8 10 10V21.6C10 21.86 10.02 22.12 10.08 22.38L11.68 30.38C11.86 31.32 12.68 31.98 13.64 31.98H34C35.1 31.98 36.18 31.1 36.4 30.02L37.94 22.36C37.98 22.12 38 21.86 38 21.6V16C38 14.9 37.1 14 36 14ZM34 21.2C34 21.46 32.72 28 32.72 28H15.28C15.28 28 14 21.48 14 21.2V10H30V20H34V21.2Z" fill=${`"${col}"`}/>
      <path d="M28 14H16V20H28V14Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Boxing;
